import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../../../../shared/_TBComponents/Button';
import Text from '../../../../../shared/_TBComponents/Text';
import CalendarPicker from '../CalendarPicker';

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background: #F7F7F7;
  border: 1px solid #9e9e9e;
  border-radius: 4px;
`;

const SelectButtonRow = styled.div`
  display: flex;
  gap: 6px;
  flex-shrink: 0;
`;

const GroupAthletesForm = ({ athletes, values, setFieldValue }) => {
  const athleteOptions = useMemo(
    () => athletes.map((a) => ({ id: a.id, name: `${a.first || ''} ${a.last || ''}`.trim() })),
    [athletes],
  );

  return (
    <FormWrapper>
      <InfoWrapper>
        <Text styledTextProps={{ fontSize: '16px', fontWeight: 600 }}>
          Groups are used to organize a set of athletes together for communication, ranking,
          reporting and/or Free-Form Program access purposes. An athlete can be assigned to an
          unlimited number of groups.
        </Text>
      </InfoWrapper>

      <Text styledTextProps={{ fontSize: '16px', fontWeight: 700, marginTop: '8px' }}>
        Athletes in Group
      </Text>

      <CalendarPicker
        allCalendars={athleteOptions}
        value={values.athletes}
        onChange={(val) => setFieldValue('athletes', val)}
        leftLabel='Available'
        rightLabel='Assigned'
        searchPlaceholder='Search Athletes'
        instructionText='Click names to move between access boxes'
        instructionActions={(
          <SelectButtonRow>
            <Button
              name='Assign All'
              bgColor='white'
              borderColor='#ddd'
              txtColor='#333'
              customBorderRadius='4px'
              styledTextProps={{ fontSize: '11px', fontWeight: 700, whiteSpace: 'nowrap' }}
              styledWrapperProps={{
                height: '26px',
                padding: '4px 8px',
                whiteSpace: 'nowrap',
              }}
              onClick={(e) => { e.preventDefault(); setFieldValue('athletes', athleteOptions); }}
            />
            <Button
              name='Assign None'
              bgColor='white'
              borderColor='#ddd'
              txtColor='#333'
              customBorderRadius='4px'
              styledTextProps={{ fontSize: '11px', fontWeight: 700, whiteSpace: 'nowrap' }}
              styledWrapperProps={{
                height: '26px',
                padding: '4px 8px',
                whiteSpace: 'nowrap',
              }}
              onClick={(e) => { e.preventDefault(); setFieldValue('athletes', []); }}
            />
          </SelectButtonRow>
        )}
      />
    </FormWrapper>
  );
};

GroupAthletesForm.propTypes = {
  athletes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    first: PropTypes.string,
    last: PropTypes.string,
  })),
  values: PropTypes.shape({
    athletes: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })),
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

GroupAthletesForm.defaultProps = {
  athletes: [],
};

export default GroupAthletesForm;
